import Regex from './regex';

export const rgb2Array = rgb => {
  let rgbString = rgb;
  let sep = rgbString.indexOf(',') > -1 ? ',' : ' ';
  let rgbArray = rgbString.split(sep);
  return rgbArray;
};
export const rgbString2Array = rgb => {
  if (rgb === '') return;
  if (rgb === undefined) return;
  const match = rgb.match(Regex.STRING_BETWEEN_BRACKETS);
  if (!match) {
    return;
  }
  let rgbString = match[1];
  let rgbArray = rgbString.split(', ');
  rgbArray = rgbArray.length === 1 ? rgbArray[0].split(' ') : rgbArray;
  let index = rgbArray.indexOf('/');
  if (index !== -1) {
    rgbArray.splice(index, 1);
  }
  rgbArray = rgbArray.map(Number);
  return rgbArray;
};

export const rgbaString2Array = (rgba, isString = false) => {
  if (rgba === '') return;
  let rgbaString = rgba.match(Regex.STRING_BETWEEN_BRACKETS)[1];
  let rgbaArray = rgbaString.split(',');
  let index = rgbaArray.indexOf('/');
  if (index !== -1) {
    rgbaArray.splice(index, 1);
  }
  rgbaArray = rgbaArray.map(a => (a.trim() !== 'null' ? Number(a) : 0));
  if (isString) {
    rgbaArray = rgbaArray.map(a => `${a}`);
  }
  return rgbaArray;
};

export const hexToRgb = hex => {
  if (new RegExp(Regex.HEX_TO_RGB).test(hex)) {
    const subString = hex.substr(1);
    hex = subString.length === 3 ? subString.replace(/(.)/g, '$1$1') : subString;
    const color = parseInt(hex, 16);
    const rgb = 'rgb(' + [(color >> 16) & 255, (color >> 8) & 255, color & 255].join(', ') + ')';
    return rgb;
  }
};
export const hexToRgbArr = hex => {
  if (new RegExp(Regex.HEX_TO_RGB).test(hex)) {
    const subString = hex.substr(1);
    hex =
      subString.length === 3 || subString.length == 4
        ? subString.replace(/(.)/g, '$1$1')
        : subString;
    const color = parseInt(hex, 16);
    return [(color >> 16) & 255, (color >> 8) & 255, color & 255];
  }
};

export const rgb2Hex = rgb => {
  let hex = '#';
  rgb.forEach(color => {
    color = parseInt(color).toString(16);
    hex += color.length === 1 ? '0' + color : color;
  });
  return hex;
};

export const rgbp2Hex = rgb => {
  // convert %s to 0–255
  for (let R in rgb) {
    let r = rgb[R];
    if (r.indexOf('%') > -1) rgb[R] = Math.round((r.substr(0, r.length - 1) / 100) * 255);
  }

  let r = (+rgb[0]).toString(16),
    g = (+rgb[1]).toString(16),
    b = (+rgb[2]).toString(16);

  if (r.length === 1) r = '0' + r;
  if (g.length === 1) g = '0' + g;
  if (b.length === 1) b = '0' + b;

  return '#' + r + g + b;
};

export const rgbpa2Hex = rgba => {
  // strip the slash if using space-separated syntax
  if (rgba.indexOf('/') > -1) rgba.splice(3, 1);

  for (let R in rgba) {
    let r = rgba[R];
    if (r.indexOf('%') > -1) {
      let p = r.substr(0, r.length - 1) / 100;

      if (R < 3) {
        rgba[R] = Math.round(p * 255);
      } else {
        rgba[R] = p;
      }
    }
  }

  let r = (+rgba[0]).toString(16),
    g = (+rgba[1]).toString(16),
    b = (+rgba[2]).toString(16),
    a = Math.round(+rgba[3] * 255).toString(16);

  if (r.length === 1) r = '0' + r;
  if (g.length === 1) g = '0' + g;
  if (b.length === 1) b = '0' + b;
  if (a.length === 1) a = '0' + a;

  return '#' + r + g + b + a;
};

export const rgbaConversion = rgbColor => {
  let rgbString = rgbColor.match(Regex.STRING_BETWEEN_BRACKETS)[1];
  let opacity = rgbString.substring(rgbString.lastIndexOf('/ ') + 1, rgbString.lastIndexOf('%'));
  opacity = opacity / 100;
  rgbString = rgbString.split(' ');
  let rgba = `rgba(${rgbString[0]}, ${rgbString[1]}, ${rgbString[2]}, ${opacity})`;
  const result = rgba2hex(rgba);
  return result;
};

export const rgba2hex = rgba => {
  let a = null;
  let rgb = rgba.replace(/\s/g, '').match(Regex.RGBA);
  let alpha = ((rgb && rgb[4]) || '').trim();
  let hex = rgb
    ? (rgb[1] | (1 << 8)).toString(16).slice(1) +
      (rgb[2] | (1 << 8)).toString(16).slice(1) +
      (rgb[3] | (1 << 8)).toString(16).slice(1)
    : rgba;
  a = alpha !== '' ? alpha : '01';
  a = ((a * 255) | (1 << 8)).toString(16).slice(1);
  hex = hex + a;
  return `#${hex}`;
};

export const clickToDownload = async (blob, fileName = 'file') => {
  const href = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = href;
  link.download = fileName;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadHref = (href, fileName = 'file') => {
  const link = document.createElement('a');
  link.href = href;
  link.download = fileName;
  link.setAttribute('target', '_blank');
  link.setAttribute('download', fileName);
  console.log({ link });
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const jsonToFile = (data, fileName = 'file') => {
  const json = JSON.stringify(data);
  const blob = new Blob([json], { type: 'application/json' });
  return clickToDownload(blob, `${fileName}.json`);
};

export const xmlToFile = (data, fileName = 'file') => {
  const blob = new Blob([data], { type: 'text/xml' });
  return clickToDownload(blob, `${fileName}.xml`);
};

export const toZipFile = (data, fileName = 'file') => {
  const blob = new Blob([data], { type: "application/zip" });
  return clickToDownload(blob, `${fileName}.zip`);
}

export const scrollToElement = (id, container, start) => {
  var target = document.getElementById(id);
  target && scrollPageTo(target, container, 500, start);
};

export const scrollPageTo = (to, container, duration = 500, overrideStatrt = undefined) => {
  //t = current time  //b = start value  //c = change in value  //d = duration
  const easeInOutQuad = function(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };

  return new Promise((resolve, reject) => {
    let element = document.getElementById(container);
    if (typeof to === 'string') {
      to = document.querySelector(to) || reject();
    }
    if (typeof to !== 'number') {
      to = to.getBoundingClientRect().top + element.scrollTop;
    }
    let start = overrideStatrt !== undefined ? overrideStatrt : element.scrollTop,
      change = to - start,
      currentTime = 0,
      increment = 20;

    const animateScroll = function() {
      currentTime += increment;
      let val = easeInOutQuad(currentTime, start, change, duration) - 120;
      element.scrollTop = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      } else {
        resolve();
      }
    };
    animateScroll();
  });
};

export const getBase64 = image => {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(image);
  });
};

export const getFileBlob = image => {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.onloadend = e => {
      const blob = new Blob([new Uint8Array(e.target.result)], { type: image.type });
      resolve(blob);
    };
    reader.readAsArrayBuffer(image);
  });
};

export const getImageDimensions = url =>
  new Promise((resolve, reject) => {
    const img = new Image();
    // the following handler will fire after the successful loading of the image
    img.onload = () => {
      const { naturalWidth, naturalHeight } = img;
      const styles = {
        width: `${naturalWidth}px`,
        height: `${naturalHeight}px`,
      };
      resolve(styles);
    };
    // and this handler will fire if there was an error with the image (like if it's not really an image or a corrupted one)
    img.onerror = e => {
      console.error('Error in downloading image :: ', e);
      reject('There was some problem with the image.');
    };

    img.src = url;
  });

export const dateConversion = (date, showText = true) => {
  let dateObj = new Date(date);
  let month = dateObj.getMonth() + 1;
  let day = dateObj.getDate();
  let year = dateObj.getFullYear();
  let formdate = (showText ? 'Edited on ' : '') + day + '-' + month + '-' + year;
  return formdate;
};

export const dayConversion = date => {
  let dateObj = new Date(date);
  let day = dateObj.getDate();
  let formday = day;

  return formday;
};

export const monthConversion = date => {
  let dateObj = new Date(date);
  let formmonth = dateObj.toLocaleString('en-US', { month: 'short' });

  return formmonth;
};

let romanArray = [
  'i',
  'ii',
  'iii',
  'iv',
  'v',
  'vi',
  'vii',
  'viii',
  'ix',
  'x',
  'xi',
  'xii',
  'xiii',
  'xiv',
  'xv',
  'xvi',
  'xvii',
  'xviii',
  'xix',
  'xx',
  'xxi',
  'xxii',
  'xxiii',
  'xxiv',
  'xxv',
  'xxvi',
  'xxvii',
  'xxviii',
  'xxix',
  'xxx',
];
let alphaArray = [
  'a',
  'b',
  'c',
  'd',
  'e',
  'f',
  'g',
  'h',
  'i',
  'j',
  'k',
  'l',
  'm',
  'n',
  'o',
  'p',
  'q',
  'r',
  's',
  't',
  'u',
  'v',
  'w',
  'x',
  'y',
  'z',
];

export const generateBullets = (content = { count: 0, bulletType: 'decimal' }) => {
  const { bulletType, count } = content;
  let bulletValue = '';
  switch (bulletType) {
    case 'decimal':
      bulletValue = `${count + 1}.`;
      break;
    case 'lower-alpha':
      bulletValue = `${alphaArray[count % 26]}.`;
      break;
    case 'lower-roman':
      bulletValue = `${romanArray[count % 30]}.`;
      break;
    default:
      bulletValue = '.';
      break;
  }
  return bulletValue;
};

export const generateBulletsWithIndent = (listIndex, indent = 0, type = 'ordered') => {
  if (type === 'ordered') {
    let bulletType;
    if ((indent % 3) === 0) {
      bulletType = 'decimal';
    } else if ((indent % 3) === 1) {
      bulletType = 'lower-alpha';
    } else if ((indent % 3) === 2) {
      bulletType = 'lower-roman';
    }
    return generateBullets({ count: listIndex, bulletType });
  } else {
    return generateBullets({ count: listIndex });
  }
}

export const deepCopy = (object) => {
  return JSON.parse(JSON.stringify(object));
};

const _MS_PER_DAY = 1000 * 60 * 60 * 24;

// a and b are javascript Date objects
export const dateDiffInDays = (a, b) => {
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
};

export const saveByteArray = (reportName, byte, downloadPdf=true) => {
  var blob = new Blob([byte], { type: 'application/pdf' });
  if(downloadPdf){
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    var fileName = reportName;
    link.download = fileName;
    link.click();
  }else{
    const url = window.URL.createObjectURL(blob);
    return url;
  }
};

export const getLastTwelveMonths = () => {
  let monthName = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  let result = [];
  let d = new Date();
  d.setDate(1);
  for (let i = 0; i <= 11; i++) {
    result.push(
      monthName[d.getMonth()],
    );
    d.setMonth(d.getMonth() - 1);
  }
  return result.reverse();
};
const convertDate = dateVal => {
  var dd = String(dateVal.getDate()).padStart(2, '0');
  var mm = String(dateVal.getMonth() + 1).padStart(2, '0');
  var yyyy = dateVal.getFullYear();
  let type = yyyy + '-' + mm + '-' + dd;
  return type;
};

export const getWeek = () => {
  const today = new Date();

  let hour = today.getHours();
  hour = ('0' + hour).slice(-2);
  // To make sure the hour always has 2-character-format

  let minute = today.getMinutes();
  minute = ('0' + minute).slice(-2);
  // To make sure the minute always has 2-character-format

  let second = today.getSeconds();
  second = ('0' + second).slice(-2);
  // To make sure the second always has 2-character-format

  var time = hour + ':' + minute + ':' + second;
  var startDate = convertDate(new Date(new Date().setDate(today.getDate() - 7))) + ' ' + time;
  var endDate = convertDate(today) + ' ' + time;
  return { startDate, endDate };
};

export const dateTimeConversion = (value, includeDate, includeTime, includeSeconds) => {
  const dateTime = new Date(value);

  const doubleDigit = num => {
    return num < 10 ? '0' + num : num;
  };

  const nth = d => {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  let date = doubleDigit(dateTime.getDate());

  let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  let month = months[dateTime.getMonth()];

  let year = dateTime.getFullYear();

  let hours = doubleDigit(
    dateTime.getHours() > 12 ? dateTime.getHours() % 12 : dateTime.getHours(),
  );

  let minutes = doubleDigit(dateTime.getMinutes());

  let seconds = doubleDigit(dateTime.getSeconds());

  let session = dateTime.getHours() >= 12 ? 'pm' : 'am';

  let result = '';

  if (includeDate) {
    result += date + nth(date) + ' ' + month + ' ' + year;
  }
  if (includeTime && includeSeconds) {
    result += ' ' + hours + ':' + minutes + ':' + seconds + ' ' + session;
  } else if (includeTime) {
    result += ' ' + hours + ':' + minutes + ' ' + session;
  }
  return result;
};

// The function is designed to provide a single name as the output when the first name is equal to the second name
export const removeDuplicateFirstNames = name => {
  const parts = name?.split(' ');
  if (parts?.length > 1 && parts[0] === parts.slice(1).join(' ')) {
    return parts[0]; // Display only the first name if it's the same as the second name
  }
  return name; // Display the entire name otherwise
};

export const getTodaysDateWithFormat = (format = 'dd-mm-yyyy') => {
  // Get the current date
  var today = new Date();

  // Get the day of the month
  var dd = today.getDate();

  // Get the month (adding 1 because months are zero-based)
  var mm = today.getMonth() + 1;

  // Get the year
  var yyyy = today.getFullYear();

  // Add leading zero if the day is less than 10
  if (dd < 10) {
    dd = '0' + dd;
  }

  // Add leading zero if the month is less than 10
  if (mm < 10) {
    mm = '0' + mm;
  }
  today = dd + '-' + mm + '-' + yyyy;
  return today;
};

export const measurementConversion = (val, converTo) => {
  if (converTo === 'px') {
    return Math.round(parseFloat(val) * 3.779528);
  } else {
    return Math.round(parseFloat(val) / 3.779528);
  }
};

const UNIT_TO_PX = {
  px: 1,
  mm: 3.779528,
  cm: 37.79528,
  inch: 96
};

export const measurementUnitConversion = (
  value,
  from = 'mm',
  to = 'px'
) => {
  const num = Number(value);
  if (Number.isNaN(num)) return 0;

  const fromRate = UNIT_TO_PX[from];
  const toRate = UNIT_TO_PX[to];

  if (!fromRate || !toRate) {
    console.warn(`Unsupported unit conversion: ${from} → ${to}`);
    return 0;
  }

  const result = (num * fromRate) / toRate;

  return result
};


export const convertExcelSerialDate = (excelSerialDate) => {
  if (!Number.isFinite(excelSerialDate)) {
    return excelSerialDate
  }
  const baseDate = new Date('1899-12-30');  // Excel base date (December 30, 1899)

  // Convert the Excel serial date to JavaScript date
  const dateInMilliseconds = baseDate.getTime() + (excelSerialDate) * 24 * 60 * 60 * 1000;
  const formattedDate = new Date(dateInMilliseconds);

  // Format the date as 'dd-mm-yyyy'
  const day = formattedDate.getDate().toString().padStart(2, '0');
  const month = (formattedDate.getMonth() + 1).toString().padStart(2, '0');  // Month is zero-based
  const year = formattedDate.getFullYear();

  return `${day}-${month}-${year}`;
}

export const stringifyEquals = (a, b) => {
  return JSON.stringify(a) === JSON.stringify(b);
};

export const getImageSize = file => {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.onload = event => {
      const img = new Image();
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
      img.src = event.target.result;
    };
    reader.readAsDataURL(file);
  });
};

const randomChar = () => String.fromCharCode(0 | (Math.random() * 26 + 97));
const randomLineOfChars = noOfChars => () =>
  Array(noOfChars)
    .fill()
    .map(randomChar)
    .join('');
export const random4Characters = randomLineOfChars(4);

export const getZigZagPosition = (id, colsPerRow) => {
  const row = Math.ceil(id / colsPerRow);
  const column =
    row % 2 === 1
      ? ((id - 1) % colsPerRow) + 1
      : colsPerRow - ((id - 1) % colsPerRow);
  return { row, column };
}